function PageCache(config, renderer) {
  let pages = {};

  this.page = function (pageName) {
    if (!pages[pageName]) {
      let constructor = window[pageName];
      if (typeof constructor === 'undefined') {
        throw new Error('Unknown page: ' + pageName);
      }
      pages[pageName] = new constructor(config, renderer);
    }
    return pages[pageName];
  }
}